import { combineReducers } from "redux";
import adminUserReducer from "./user-list.slice"

const adminUserRootReducer = combineReducers({
    list: adminUserReducer
})

export default adminUserRootReducer